import { useState } from 'react'

import {
  Box, DashboardModule, SectionDivider,
} from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useAdCopy from '@hooks/useAdCopy'

import AdCopyItemHeader from '@components/AdCopyItemHeader'
import ConversationContainer from '@components/ConversationContainer'

import type { AdCopyModel } from '@models/types'

import AdCopy from './AdCopy'
import AdCopyActions from './AdCopyActions'

const defaultState = {
  commentMode: false,
}

interface AdCopyReviewItemProps {
  adCopy: AdCopyModel,
  campaignId: number,
  title: string,
}

const AdCopyReviewItem = (props: AdCopyReviewItemProps) => {
  const {
    adCopy,
    adCopy: {
      description,
      tagline,
    },
    campaignId,
    title,
  } = props

  const [state, setState] = useState(defaultState)
  const { commentMode } = state

  const currentUserPayload = useCurrentUser()
  const { isProviderUser } = currentUserPayload

  const adCopyPayload = useAdCopy(adCopy)
  const {
    callbacks: {
      assignAdCopiesToCampaign,
      createOrUpdateAdCopy,
    },
  } = adCopyPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title={title}
      headerRight={(
        <AdCopyItemHeader
          adCopy={adCopy}
          campaignId={campaignId}
          commentsCallback={!isProviderUser ? (() => setState({ commentMode: !commentMode })) : undefined}
        />
      )}
    >
      <AdCopy description={description} tagline={tagline} />

      <DashboardModule.Footer
        boxProps={{ alignItems: 'end', flexDirection: 'column' }}
      >
        {!isProviderUser && (
          <AdCopyActions
            adCopy={adCopy}
            campaignId={campaignId}
            callbacks={{ assignAdCopiesToCampaign, createOrUpdateAdCopy, setState }}
          />
        )}

        {commentMode && (
          <Box flexDirection="column" paddingTop="medium">
            <SectionDivider>CHANGES REQUESTED</SectionDivider>

            <ConversationContainer
              commentsBoxProps={{ maxHeight: '400px' }}
              conversation={{
                campaign_id: campaignId,
                subject_id: adCopy.id,
                subject_type: 'AdCopy',
              }}
              requestOptions={{
                include_conversation_comments: true,
              }}
            />
          </Box>
        )}
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default AdCopyReviewItem
